import React, { useRef, useEffect } from 'react'
import { bem } from '@argos/utils'

const cn = bem({ prefix: 'lc-', block: 'message-input' })

const MESSAGE_CHARACTER_LIMIT = 4000

const MessageInput = (props) => {
  const { newMessage, onChange, focusInput } = props

  const textInput = useRef(null)

  useEffect(() => {
    if (newMessage === '' || focusInput) {
      textInput.current.focus()
    }
  }, [newMessage, focusInput])

  return (
    <input
      autoComplete='off'
      className={cn()}
      type='text'
      name='newMessage'
      placeholder={`Type Something... (${MESSAGE_CHARACTER_LIMIT} characters max.)`}
      value={newMessage}
      onChange={onChange}
      ref={textInput}
      maxLength={MESSAGE_CHARACTER_LIMIT}
    />
  )
}

export default MessageInput
